import Worker from "worker-loader!./FeatureProcessorWorker.js";
import * as Comlink from "comlink";

const worker = Comlink.wrap(new Worker());

export const getFeatureCollectionsLength = worker.getFeatureCollectionsLength;
export const categorizeFeaturesInCollection =
  worker.categorizeFeaturesInCollection;
